import React, {Component} from "react";
import OrderAdmin from "./OrdenAdminView";
import {OrderAdminService} from "../../../service/operation/orderAdmin/OrderAdminService";
import {CatalogService} from "../../../service/catalog/CatalogService";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {
    INSERT_ORDER_TRADE_ADMIN_ROUTE,
    TAKE_ORDER_ADMIN_ROUTE,
    UPDATE_ORDER_ADMIN_ROUTE
} from "../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";
import ContextMenu from "../../../components/contextMenu";

export default class OrderAdminContainer extends Component {
    constructor(props) {
        super(props);

        this.orderAdminService = new OrderAdminService();
        this.catalogService = new CatalogService();
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        }

        this.loading = this.loading.bind(this);
        this.handleSelectOrderAdmin = this.handleSelectOrderAdmin.bind(this);
        this.saveFilters = this.saveFilters.bind(this);
        this.saveCheckFilters = this.saveCheckFilters.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.getInstitutionCatalog = this.getInstitutionCatalog.bind(this);
        this.getAdminOrders = this.getAdminOrders.bind(this);
        this.insertOrderTradeAdminScreen = this.insertOrderTradeAdminScreen.bind(this);
        this.resetSelectedOrderAdmin = this.resetSelectedOrderAdmin.bind(this);
        this.takeOrderAdmin = this.takeOrderAdmin.bind(this);
        this.updateOrderAdmin = this.updateOrderAdmin.bind(this);
        this.rejectOrderAdmin = this.rejectOrderAdmin.bind(this);
        this.orderAdminActionTemplate = this.orderAdminActionTemplate.bind(this);

        this.state = {
            isLoading: true,
            catInstitutionCatalog: this.getInstitutionCatalog(),
            catInstitutionLenderFilter: '',
            catInstitutionBorrowerFilter: '',
            orderAdminList: [],
            selectedOrderAdmin: '',
            options: [],
            isAdmin: true,
        };

        this.getAdminOrders();
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : ''
            });
        }
    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    insertOrderTradeAdminScreen() {
        this.props.history.push({
            pathname: INSERT_ORDER_TRADE_ADMIN_ROUTE,
        });
    }

    saveFilters(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,})
    }

    saveCheckFilters(event) {
        const {name, checked} = event.target;
        this.setState({[name]: checked,})
    }

    clearFilters() {
        this.setState({
            catInstitutionLenderFilter: '',
            catInstitutionBorrowerFilter: '',
            isAdmin: true,
        })
    }

    getAdminOrders() {
        this.loading();
        this.orderAdminService.getAdminOrders(
            this.state.catInstitutionLenderFilter,
            this.state.catInstitutionBorrowerFilter,
            this.state.isAdmin
        ).then(
            res => {
                this.setState({
                    isLoading: false,
                    orderAdminList: res,
                    anchorEl: null,
                })
            })
    }

    getInstitutionCatalog() {
        this.loading();
        this.catalogService.getInstitutionCatalog().then(
            res => {
                this.setState({
                    isLoading: false,
                    catInstitutionCatalog: res,
                })
            }
        )
    }

    handleSelectOrderAdmin(event) {
        this.setState({
            selectedOrderAdmin: event.value,
        });
    }

    updateOrderAdmin() {
        this.props.history.push({
            pathname: UPDATE_ORDER_ADMIN_ROUTE,
            state: {
                selectedOrderAdmin: this.state.selectedOrderAdmin,
            },

        });
    }

    takeOrderAdmin() {
        this.props.history.push({
            pathname: TAKE_ORDER_ADMIN_ROUTE,
            state: {
                selectedOrderAdmin: this.state.selectedOrderAdmin,
            },
        });
    }

    rejectOrderAdmin() {
        this.loading();
        this.orderAdminService.rejectOrderAdmin(
            this.state.selectedOrderAdmin.idFolioPrest,
            this.state.selectedOrderAdmin.idFolioValPrestable,
            this.state.selectedOrderAdmin.idFolioSolVal,
            this.state.selectedOrderAdmin.statusPv
        ).then(res => {
            this.getAdminOrders();
            this.resetSelectedOrderAdmin();
        });
    }

    resetSelectedOrderAdmin() {
        this.setState({
            selectedOrderAdmin: ''
        })
    }

    orderAdminActionTemplate(rowData) {
        let optionsMenu = [];

        if (rowData['statusPv'] === '') {
            optionsMenu.push({label: "Tomar", action: this.takeOrderAdmin});
            optionsMenu.push({label: "Actualizar", action: this.updateOrderAdmin});
        }
        if (rowData['statusPv'] === '' || rowData['statusPv'] === 'CG' || rowData['statusPv'] === 'FecValor') {
            optionsMenu.push({label: "Cancelar", action: this.confirmationRef.openConfirmationMessage});
        }

        return (
            <ContextMenu menuOptions={optionsMenu}/>
        );
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        this.confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                            invisible={true}
                                            legend="¿Está seguro que desea cancelar la postura?"
                                            action={this.rejectOrderAdmin}/>;

        return <OrderAdmin
            isLoading={this.state.isLoading}
            messagesGrowl={messagesGrowl}
            handleSelectOrderAdmin={this.handleSelectOrderAdmin}
            selectedOrderAdmin={this.state.selectedOrderAdmin}
            insertOrderTradeAdminScreen={this.insertOrderTradeAdminScreen}
            orderAdminTemplate={this.orderAdminActionTemplate}
            catInstitutionCatalog={this.state.catInstitutionCatalog}
            catInstitutionLenderFilter={this.state.catInstitutionLenderFilter}
            catInstitutionBorrowerFilter={this.state.catInstitutionBorrowerFilter}
            isAdmin={this.state.isAdmin}
            saveFilters={this.saveFilters}
            saveCheckFilters={this.saveCheckFilters}
            clearFilters={this.clearFilters}
            getAdminOrders={this.getAdminOrders}
            orderAdminList={this.state.orderAdminList}
            rejectOrderAction={this.rejectOrderAction}
            confirmationMsg={this.confMsg}
            searchAll={this.getAdminOrders}
        />
    }
};
